import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import FalconCloseButton from '../../components/common/FalconCloseButton';
import '../../styles/calendar.css';
import ProfileBanner from './Banner';
import TeamVacationsCalendar from './TeamVacationsCalendar';
import VacationSection from './VacationSection';

const Profile = () => {
    const { id } = useParams();
    const { showErrorToast, showSuccessToast } = useToast();
    const { token, setToken, idUsuario, idCatTipoUsuario, profileImage } = useToken();

    const [cargando, setCargando] = useState(true);
    const [procesandoModal, setProcesandoModal] = useState(false);
    const [dataForm, setDataForm] = useState({});

    const [perfil, setPerfil] = useState([]);
    const [showModalFoto, setShowModalFoto] = useState(false);
    const [imagenPerfil, setImagenPerfil] = useState("");
    const [refreshVacations, setRefreshVacations] = useState(0);

    // Estado compartido para conocer los días disponibles de forma reactiva
    const [diasDisponibles, setDiasDisponibles] = useState(0);
    const [savingVacation, setSavingVacation] = useState(false);

    const obtenerPerfil = async () => {
        try {
            const response = await fetch("/api/perfil/obtenerDatosPerfil/?id=" + (!id ? idUsuario : id), {
                method: 'GET',
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType == 1) {
                    const detalles = JSON.parse(data.detalles);
                    const datosUsuario = detalles['table2'][0];
                    setPerfil(datosUsuario);
                    console.log('fotito', datosUsuario)
                    setImagenPerfil(profileImage)
                    console.log('fotito', datosUsuario)

                    // Disparar de inmediato el cálculo de vacaciones en cascada
                    if (datosUsuario?.idUsuario) {
                        await cargarDiasDisponibles(datosUsuario.idUsuario);
                    }
                } else {
                    showErrorToast(data.vMessage);
                }
            } else if (response.status == 401) {
                setToken(null);
                window.location.reload();
            }
        } catch (e) {
            console.error(e);
        } finally {
            setCargando(false);
        }
    };


    const cargarDiasDisponibles = async (userId) => {
        try {
            const response = await fetch(`/api/vacaciones/CalcularDiasVacacionesLFT?idUsuario=${userId}`, {
                method: 'GET',
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            });
            const data = await response.json();
            if (data.iResponseType === 1 && data.detalles) {
                const detalles = JSON.parse(data.detalles);
                const resumen = detalles.table2?.[0] || detalles.Table2?.[0];
                setDiasDisponibles(resumen ? resumen.iDiasDisponibles : 0);
            }
        } catch (error) {
            console.error("Error al calcular días:", error);
        }
    };

    // Nueva función controladora enviada al calendario
    const handleDirectVacationRequest = async (fechasSeleccionadas, motivo = '') => {
        setSavingVacation(true);
        try {
            const requestBody = {
                solicitud: {
                    idUsuario: perfil.idUsuario.toString(),
                    fechasSolicitadas: fechasSeleccionadas,
                    vMotivoSolicitud: motivo ? motivo.trim() : ""

                }
            };

            const response = await fetch("/api/vacaciones/SolicitarVacaciones", {
                method: 'POST',
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (data.iResponseType === 1) {
                showSuccessToast(data.vMessage || 'Solicitud de vacaciones enviada (Estado: Pendiente)');
                await cargarDiasDisponibles(perfil.idUsuario); // Recalcular días
                setRefreshVacations(prev => prev + 1); // Forzar refresco visual
                return true;
            } else {
                throw new Error(data.vMessage || 'Error al procesar la solicitud');
            }
        } catch (error) {
            showErrorToast(error.message);
            return false;
        } finally {
            setSavingVacation(false);
        }
    };

    const handleVacationUpdate = async () => {
        if (perfil?.idUsuario) await cargarDiasDisponibles(perfil.idUsuario);
        setRefreshVacations(prev => prev + 1);
    };

    const onSubmitCargarFoto = async () => {

        if (dataForm.vArchivo.size > 3000 * 1024) { // Tamaño máximo: 40KB
            alert("El archivo es demasiado grande. Debe ser menor a 40KB");
            return;
        }

        if (!["image/jpeg"].includes(dataForm.vArchivo.type)) { // Solo imágenes JPG
            alert("Solo se permiten archivos JPG");
            return;
        }


        setProcesandoModal(true);
        var data = new FormData()
        data.append('FormFile', dataForm.vArchivo);

        console.log("data",data)

        const response = await fetch("/api/perfil/CargarFoto", {
            method: 'POST',
            body: data,
            headers:
            {
                'Authorization': 'Bearer ' + token
            }

        }).catch((error) => {

            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data.iResponseType == 1) {
                obtenerPerfil();
                setShowModalFoto(false);
                showSuccessToast(data.vMessage);
            } else {

                showErrorToast(data.vMessage);
            }

        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setProcesandoModal(false);
        setShowModalFoto(false);
    };


    useEffect(() => {
        obtenerPerfil();
    }, [id]);

    console.log("imagen",dataForm)

    return (
        <>
            {cargando ? (
                <h5><Spinner animation="border" variant="primary" className="me-2" /> Cargando Perfil...</h5>
            ) : (
                <>
                    <ProfileBanner
                        perfil={perfil}
                        setShowModalFoto={setShowModalFoto}
                        imagenPerfil={imagenPerfil}
                        onVacationUpdate={handleVacationUpdate}
                    />
                    <div className="mb-4">
                        <TeamVacationsCalendar
                            diasDisponibles={diasDisponibles}
                            onSelectionSubmit={handleDirectVacationRequest}
                            saving={savingVacation}
                            idUsuarioSeleccionado={perfil?.idUsuario}
                        />
                    </div>

                    {(!id || id === idUsuario.toString() || idCatTipoUsuario == "1") && (
                        <VacationSection
                            perfil={perfil}
                            refreshTrigger={refreshVacations}
                        />
                    )}

                </>
            )}
            <Modal
                show={showModalFoto}
                onHide={() => setShowModalFoto(false)}
                size="md"
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title>Cambiar foto</Modal.Title>
                    <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalFoto(false); }} />
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Adjuntar fotograf&iacute;a</Form.Label>
                        <Form.Control
                            type="file"
                            size="sm"
                            required
                            onChange={(e) => setDataForm({
                                ...dataForm,
                                vArchivo: e.target.files[0],
                                vNombreDocumento: e.target.files[0].name,
                                vTipoDocumento: e.target.files[0].type,
                                vTamano: e.target.files[0].size
                            })}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => { setShowModalFoto(false) }} variant='primary' >Cerrar</Button>
                    {procesandoModal ? <Button variant="primary" disabled>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Procesando...
                    </Button> : <Button type="button" onClick={() => onSubmitCargarFoto()} variant='success' >Cambiar Foto</Button>}
                </Modal.Footer>

            </Modal>
        </>

    );
};



export default Profile;